// Module
var code = `<div class="deck-circles">
  {{#circles}}
  <div class="deck-circle deck-circle--{{attrTier}}">
    <span class="deck-circle-tier">{{tier}}</span>
    <span class="deck-circle-value">{{value}}</span>
  </div>
  {{/circles}}
</div>
<ul class="deck-circle-notes">
  {{#circles}}
  <li class="deck-circle-note deck-circle-note--{{attrTier}}">
    <span class="deck-circle-note-tier">{{tier}}</span>
    <span class="deck-circle-note-copy">{{note}}</span>
  </li>
  {{/circles}}
</ul>
{{#circlesFallback}}
<figcaption class="deck-exhibit-caption">{{.}}</figcaption>
{{/circlesFallback}}
`;
// Exports
module.exports = code;